module.exports = __webpack_public_path__ + "static/media/dude.e507674c.png";